import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "circle-info-17", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 17", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fill: "none", fillRule: "evenodd", transform: "translate(1.5 1.5)" },
        React.createElement("circle", { cx: 7, cy: 7, r: 7, stroke: "currentColor" }),
        React.createElement("g", { transform: "translate(5.5 3)" },
            React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", d: "M.5 4h1v3" }),
            React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", d: "M.5 7h2" }),
            React.createElement("circle", { cx: 1.5, cy: 1, r: 1, fill: "currentColor" }))));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
